module.exports = __webpack_public_path__ + "static/media/alphaTetris-high_score.9f21c833.png";